import { useTypedAppFormContext } from "@/core/form";
import { Label } from "@/modules/shadcn/ui/label";
import { Switch } from "@/modules/shadcn/ui/switch";
import { useTranslation } from "react-i18next";
import { limitFormOptions } from "./limitForm.options";

export function GeneralSection() {
  const { t } = useTranslation(["evaluation", "common"]);
  const form = useTypedAppFormContext({
    ...limitFormOptions,
  });

  return (
    <section className="flex flex-col gap-3">
      <h6 className="text-sm font-bold">{t("form.general")}</h6>
      <form.AppField
        name="enabled"
        children={(field) => (
          <div className="flex items-center gap-2">
            <Label
              htmlFor={field.name}
              className="text-xs text-muted-foreground"
            >
              {t("form.enabled")}
            </Label>
            <Switch
              id={field.name}
              checked={field.state.value ?? false}
              onCheckedChange={(checked) =>
                field.handleChange(Boolean(checked))
              }
              onBlur={field.handleBlur}
              aria-invalid={!!field.state.meta.errors?.[0]}
            />
          </div>
        )}
      />
      <form.AppField
        name="name"
        children={(field) => (
          <field.TextInput
            label={t("limitForm.checkName")}
            placeholder={t("limitForm.checkName")}
          />
        )}
      />
    </section>
  );
}
